"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _reactComponents = require("@cimpress/react-components");

var _sharedtypes = require("../../shared/sharedtypes");

var _constants = require("../../shared/constants");

// Shenanigans to make sure that we don't show empty rows and no pagination when number of rows is less than 10
var generateRowCountProps = function generateRowCountProps(_ref) {
  var availableVersions = _ref.availableVersions;
  var rowCountProps = availableVersions.length === 0 ? {
    defaultPageSize: 5
  } : {
    minRows: 0
  };

  if (availableVersions.length < 11 && !availableVersions.length === 0) {
    rowCountProps.showPaginationBottom = false;
  }

  return rowCountProps;
};

var VersionsList = function VersionsList(_ref2) {
  var isLoadingVersions = _ref2.isLoadingVersions,
      loadVersions = _ref2.loadVersions,
      availableVersions = _ref2.availableVersions,
      selectedVersion = _ref2.selectedVersion,
      selectedFulfillmentConfiguration = _ref2.selectedFulfillmentConfiguration,
      selectVersion = _ref2.selectVersion,
      showFulfillmentConfigurationsList = _ref2.showFulfillmentConfigurationsList,
      onFulfillmentConfigurationSelected = _ref2.onFulfillmentConfigurationSelected,
      environment = _ref2.environment;

  var _useTranslation = (0, _reactI18next.useTranslation)('versionsList'),
      t = _useTranslation.t;

  var fulfillmentConfigurationId = selectedFulfillmentConfiguration.fulfillmentConfigurationId;
  (0, _react.useEffect)(function () {
    loadVersions({
      fulfillmentConfigurationId: fulfillmentConfigurationId
    });
  }, [fulfillmentConfigurationId]);
  var currentVersionId = selectedVersion ? selectedVersion.versionId : undefined;

  var isSelected = function isSelected(versionId) {
    return versionId === currentVersionId;
  };

  var toggleSelection = function toggleSelection(key, some, row) {
    if (currentVersionId !== row.versionId) {
      selectVersion({
        versionId: row.versionId,
        versionNumber: row.versionNumber
      });
      onFulfillmentConfigurationSelected({
        fulfillmentConfigurationUrl: "".concat((0, _constants.FULFILLMENT_CONFIGURATIONS_BASE_URL)(environment), "/v0/versions/").concat(row.versionId)
      });
    }
  };

  var displayFormattedVersions = availableVersions.map(function (_ref3) {
    var versionId = _ref3.versionId,
        versionNumber = _ref3.versionNumber;
    return {
      versionNumber: versionNumber,
      versionId: versionId,
      rowContents: /*#__PURE__*/_react["default"].createElement("div", {
        className: "fcp-versionsList__rowContents"
      }, /*#__PURE__*/_react["default"].createElement("span", null, versionNumber), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        size: "sm",
        onClick: function onClick() {
          window.open("".concat((0, _constants.FULFILLMENT_CONFIGURATIONS_UI_URL)(environment), "/fulfillmentconfiguration/").concat(fulfillmentConfigurationId, "/versions/").concat(versionId));
        }
      }, t('table.moreInfoButton'))))
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactComponents.ReactTablev6, (0, _extends2["default"])({
    className: "fcp-versionsList__table",
    data: displayFormattedVersions,
    columns: [{
      Header: t('table.rowContentsHeader'),
      accessor: 'rowContents'
    }],
    loading: isLoadingVersions,
    sortable: false,
    selectable: true,
    selectType: "radio",
    keyField: "versionId",
    isSelected: isSelected,
    toggleSelection: toggleSelection,
    noDataText: t('table.noVersionsText'),
    showPageSizeOptions: false
  }, generateRowCountProps({
    availableVersions: availableVersions
  })))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
    onClick: function onClick() {
      return showFulfillmentConfigurationsList();
    }
  }, t('backButton'))));
};

VersionsList.propTypes = {
  isLoadingVersions: _propTypes["default"].bool.isRequired,
  loadVersions: _propTypes["default"].func.isRequired,
  availableVersions: _propTypes["default"].arrayOf(_sharedtypes.FulfillmentConfiguration).isRequired,
  selectedVersion: _sharedtypes.FulfillmentConfigurationVersion,
  selectedFulfillmentConfiguration: _sharedtypes.FulfillmentConfiguration.isRequired,
  selectVersion: _propTypes["default"].func.isRequired,
  showFulfillmentConfigurationsList: _propTypes["default"].func.isRequired,
  onFulfillmentConfigurationSelected: _propTypes["default"].func.isRequired,
  environment: _propTypes["default"].string.isRequired
};
VersionsList.defaultProps = {
  selectedVersion: undefined
};
var _default = VersionsList;
exports["default"] = _default;